export default {
  framerate: 60,
  speedAnimate: 20,
  removeInCorrects: false,
  backToSource: false,
  bruteForce: false,
  correctBlock: false,
  shuffleGroups: false,
  container: {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    autoFit: true,
    margin: { top: 0, left: 0, right: 0, bottom: 0 },
    padding: { top: 0, left: 0, right: 0, bottom: 0 },
    offset: { x: 0, y: 0 },
    rotation: 0,
  },
  itemsConfig: { block: false, shuffle: true, sort: false },
  shadow: { color: '#000', offset: { x: 0, y: 0 }, blur: 0 },
  border: { color: 'transparent', size: 1 },
  text: {
    color: '#000',
    size: '20px',
    textBaseline: 'middle',
    textAlign: 'left',
    bold: false,
    italic: false,
    lineHeight: 0,
    lineWidth: null,
    pos: { x: null, y: null },
  },
  frame: {
    bgrColor: 'rgba(255,255,255,1)',
    stroke: { size: 2, color: 'rgba(0,0,0,1)' },
    rad: 30,
  },
  sorting: {
    inLine: false,
    moveQueue: false,
  },
  rotate: {
    tolerance: 2,
  },
  clock: { angleMinTips: 5 },
  point: {
    color: 'rgba(0,0,0,0.3)',
    positions: {
      pos: {
        x: 0,
        y: 0,
      },
      rad: 25,
      offset: { x: 0, y: 0 },
    },
    registrationPoint: { x: 0, y: 0 },
    alwaysShow: false,
    block: false,
  },
  lines: {
    freeDrawing: false,
    connect: { color: 'black', size: 5, hideLine: true },
    select: { color: 'blue', size: 5, hideLine: false },
    good: { color: 'green', size: 5, hideLine: false },
    bad: { color: 'red', size: 5, hideLine: true },
    hideLineAnimation: false,
    hide: {
      effect: 'hide',
      speed: 1000,
      wait: 500,
    },
  },
  clones: {
    cloneNumber: 5,
    underOriginal: true,
  },
  pair: {
    pairedNumber: 2,
    checkVisible: false,
    hide: {
      effect: 'hide',
      speed: 1000,
      wait: 500,
      removeCorrect: true,
    },
  },
  hangman: {
    chances: -1,
    removeClicked: true,
  },
};
